import {
  DynamicLayoutBlocks,
  minimumUpstreamMessageWidth,
  mobileContainerWidth,
  MobileThemeColors,
  previewSectionSizes,
  PreviewThemeColors
} from '@MerchantConfigurator/constants';
import {
  closeIconRow,
  getBackgroundColor,
  getContainer,
  getEstimatedTotalLine,
  getHorizontalBars,
  getProductWithTwoDescriptionsAndTotal,
  horizontalLine
} from '@MerchantConfigurator/utils/CommonPreviewBlocks';

export const getMobilePreviewHeader = ({ darkMode }) => {
  return {
    ...getContainer({
      style: {
        width: mobileContainerWidth,
        maxWidth: previewSectionSizes['14xl'],
        justifyContent: 'start',
        marginTop: previewSectionSizes.sm
      }
    }),
    blocks: [
      ...getHorizontalBars({
        style: {
          width: previewSectionSizes['2xl'],
          height: previewSectionSizes.sm,
          backgroundColor: darkMode
            ? PreviewThemeColors.dark.componentsColor
            : PreviewThemeColors.light.componentsColor,
          marginRight: previewSectionSizes['2xl']
        },
        number: 1
      }),
      ...getHorizontalBars({
        style: {
          width: previewSectionSizes['4xl'],
          height: previewSectionSizes.sm,
          backgroundColor: darkMode
            ? PreviewThemeColors.dark.componentsColor
            : PreviewThemeColors.light.componentsColor
        },
        number: 1
      })
    ]
  };
};

export const getMobileProductPreviewHeader = ({ darkMode }) => {
  return {
    ...getContainer({
      style: {
        width: '248px',
        justifyContent: 'start',
        paddingTop: previewSectionSizes.sm,
        backgroundColor: darkMode
          ? PreviewThemeColors.dark.backgroundAlternateColor
          : PreviewThemeColors.light.backgroundMainColor
      }
    }),
    blocks: [
      ...getHorizontalBars({
        style: {
          width: previewSectionSizes['3xl'],
          height: previewSectionSizes.sm,
          backgroundColor: darkMode
            ? PreviewThemeColors.dark.componentsColor
            : PreviewThemeColors.light.componentsColor,
          marginLeft: previewSectionSizes.md,
          marginRight: previewSectionSizes['2xl']
        },
        number: 1
      }),
      ...getHorizontalBars({
        style: {
          width: previewSectionSizes['6xl'],
          height: previewSectionSizes.sm,
          backgroundColor: darkMode
            ? PreviewThemeColors.dark.componentsColor
            : PreviewThemeColors.light.componentsColor
        },
        number: 1
      }),
      closeIconRow({
        style: {
          width: previewSectionSizes['10xl'],
          justifyContent: 'end',
          marginRight: previewSectionSizes.xs
        }
      })
    ]
  };
};

export const getMobileButton = ({ darkMode, message }) => {
  return {
    //button container
    ...getContainer({
      style: {
        width: previewSectionSizes['14xl'],
        height: previewSectionSizes['3xl'],
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: darkMode
          ? PreviewThemeColors.dark.componentsColor
          : PreviewThemeColors.light.componentsColor,
        marginBottom: previewSectionSizes.md
      }
    }),
    blocks: [
      //button label
      {
        type: DynamicLayoutBlocks.TEXT,
        style: {
          color: darkMode
            ? PreviewThemeColors.dark.buttonLabel
            : PreviewThemeColors.light.buttonLabel
        },
        message
      }
    ]
  };
};

export const getMobilePreviewButton = ({ darkMode, message }) => {
  return {
    ...getContainer({
      style: {
        width: '248px',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: darkMode
          ? PreviewThemeColors.dark.backgroundAlternateColor
          : PreviewThemeColors.light.backgroundMainColor,
        marginBottom: previewSectionSizes.md
      }
    }),
    blocks: [
      {
        //button container
        ...getContainer({
          style: {
            width: previewSectionSizes['14xl'],
            height: previewSectionSizes['3xl'],
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: darkMode
              ? PreviewThemeColors.dark.componentsColor
              : PreviewThemeColors.light.componentsColor,
            marginBottom: previewSectionSizes.md
          }
        }),
        blocks: [
          //button label
          {
            type: DynamicLayoutBlocks.TEXT,
            style: {
              color: darkMode
                ? PreviewThemeColors.dark.buttonLabel
                : PreviewThemeColors.light.buttonLabel
            },
            message
          }
        ]
      }
    ]
  };
};

export const getMobileTextField = ({ darkMode }) => {
  return {
    ...getContainer({
      style: {
        width: previewSectionSizes['14xl'],
        height: previewSectionSizes['xl'],
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${getBackgroundColor({
          darkMode,
          backgroundColor: 'componentsColor'
        })}`
      }
    })
  };
};

export const getMobileMainContainer = ({
  darkMode,
  lightBackgroundColor = MobileThemeColors.light.backgroundMainColor
}) =>
  getContainer({
    style: {
      flexDirection: 'column',
      backgroundColor: darkMode
        ? PreviewThemeColors.dark.backgroundMainColor
        : lightBackgroundColor,
      paddingTop: previewSectionSizes.md,
      borderRadius: '30px',
      minHeight: '525px',
      minWidth: '272px'
    }
  });

export const getPreviewBlocks = ({ darkMode, message }) => {
  return [
    ...getHorizontalBars({
      style: {
        width: previewSectionSizes['6xl'],
        height: previewSectionSizes.md,
        backgroundColor: getBackgroundColor({
          darkMode,
          backgroundColor: 'componentsColor'
        })
      },
      number: 1
    }),
    getProductWithTwoDescriptionsAndTotal({ darkMode }),
    horizontalLine({ darkMode, width: previewSectionSizes['14xl'] }),
    getProductWithTwoDescriptionsAndTotal({ darkMode }),
    horizontalLine({ darkMode, width: previewSectionSizes['14xl'] }),
    //total
    {
      ...getContainer({
        style: {
          width: previewSectionSizes['14xl'],
          justifyContent: 'space-between',
          gap: previewSectionSizes.lg,
          paddingTop: previewSectionSizes.sm
        }
      }),
      blocks: [
        ...getEstimatedTotalLine({
          darkMode,
          barWidth: previewSectionSizes['2xl']
        })
      ]
    },
    //upstream message
    {
      type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
      style: {
        width: minimumUpstreamMessageWidth,
        height: previewSectionSizes['5xl'],
        marginTop: previewSectionSizes.md
      }
    },
    getMobileButton({ darkMode, message })
  ];
};
